
import React from 'react'
import HeroTwo from '../components/heroTwo/HeroTwo'
import img from '../assets/python-advance.png';
import { Link } from 'react-router-dom';
import arrow from '../assets/arrow.svg'

export default function Blog3() {
    return (
        <div className='blog__container'>
        <HeroTwo 
        head='Blog 3'
        />
        <div className="main__blog">
        <div className="main__img">
            <Link className="paragraph" to='/blog' >
                 <img src={arrow} alt="" />
                  Back to Blog page
            </Link>
            </div>
            <div className="body__blog">
                    <div className="blog__img">
                        <img src={img} alt="" />
                    </div>
                    
                <div className="text__blog">

                    <h2>TECHNOLOGY BORN GENERATION</h2>
                    <p className='paragraph'>“Can you help me check where to change the camera settings on this phone. I want to be able to set a timer?” Mummy asked Fola her 7-year-old son. “Sure mum”. Within a few minutes, mummy’s issue had been resolved. “How were you able to know how to install all these games on my iPad?” Jim asked his 5-year-old brother with an expression of surprise on his face. Max had been watching his older brother use his iPad to download and play games. He had now become an expert in downloading and playing games.  
                    </p>
                    <p className='paragraph'>
                    Such is the generation 21st Century children are born into.  A 2-year-old child now knows how to select his or her favorite nursery rhyme on mummy’s phone.  Parents are asking their little children to help them figure things out on their devices. Kids seem to now be born with skills needed to interact with technology. It is therefore rational to expose children to how the software they interact with regularly were created.
                    </p>
                    <p className='paragraph'>
                    Many of the jobs that exist today will be replaced by automated processes in the next few years. The earlier we begin to equip our children with the relevant skills, the better. Even children that are not interested in taking up careers related to Computer Programming benefit immensely from learning to code. 
                    </p>
                    <p className='paragraph'>
                    Educationist all over the world are beginning to see the need to include Computer Science in their national curriculum. Just as Mathematics, English and Science are foundational subjects taught in schools, Computer Science has become a foundational subject that equips children with diverse sets of skills. It teaches children how to think logically and solve problems. It teaches some of the advanced topics in Mathematics in ways that are fun and more engaging than mathematics. Abstract topics become more tangible and easy to understand when applied in programming.
                    </p>
                    <p className='paragraph'>
                    A survey of American high school students carried out recently showed that Computer Science was one of their favorite subject next to only Arts. Computer Science stimulates imagination and creativity and prepares students for college and life no matter what profession they choose. As a matter of fact, a large number of undergraduate programs in developed countries now require Computer Science courses to be taken in order to satisfy graduation requirements. This includes courses in the humanities.
                    </p>
                    <p className='paragraph'>
                    Give your child this opportunity today. I believe learning to code should not be a privilege to be enjoyed by the “lucky few”. Every child deserves to learn how to code. It is a gateway that provides them an indispensable foundation for life.  
                    </p>
                   
                </div>
                

            </div>
          
            
        </div>

    </div>
    )
}
